import { validatePhoneNumberLength } from 'libphonenumber-js';

// https://www.npmjs.com/package/libphonenumber-js
export const mobileLengthStrategy = (value: string) => {
  const result = validatePhoneNumberLength(value, 'TW');

  return result === undefined;
};
